<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'

  import Promo2019Events from './Promo2019_Events.vue'
  import Promo2019Pact from './Promo2019_Pact.vue'

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */
  /** @type {ItemInfo[]} */ const itemsPromo2019Events = Promo2019Events.data().items
  /** @type {ItemInfo[]} */ const itemsPromo2019Pact = Promo2019Pact.data().items

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2022-03-15',
        major: [
          'すずコレクション',
          'リングマリィコレクション',
          '共通',
          'ファントミラージュチャンネル',
          'すみっコぐらしチャンネル',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] JR4
          // ================================================================================

          item({
            collection  : 'すずコレクション',
            id          : 'JR4-04',
            rare        : 'JR',
            name        : 'じゅんしんのピンクジュエルドレス',
            imgUrl      : '/images/items/JR4-04.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-05',
            rare        : 'JR',
            name        : 'じゅんしんのピンクジュエルシューズ',
            imgUrl      : '/images/items/JR4-05.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-06',
            rare        : 'JR',
            name        : 'じゅんしんのピンクジュエルヘアアクセ',
            imgUrl      : '/images/items/JR4-06.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'JR4-07',
            rare        : 'JR',
            name        : 'じゅんしんのイエロージュエルドレス',
            imgUrl      : '/images/items/JR4-07.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-08',
            rare        : 'JR',
            name        : 'じゅんしんのイエロージュエルシューズ',
            imgUrl      : '/images/items/JR4-08.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-09',
            rare        : 'JR',
            name        : 'じゅんしんのイエロージュエルヘアアクセ',
            imgUrl      : '/images/items/JR4-09.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'JR4-10',
            rare        : 'JR',
            name        : 'じゅんしんのブルージュエルドレス',
            imgUrl      : '/images/items/JR4-10.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-11',
            rare        : 'JR',
            name        : 'じゅんしんのブルージュエルシューズ',
            imgUrl      : '/images/items/JR4-11.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-12',
            rare        : 'JR',
            name        : 'じゅんしんのブルージュエルヘアアクセ',
            imgUrl      : '/images/items/JR4-12.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'JR4-13',
            rare        : 'JR',
            name        : 'じゅんしんのゴールドジュエルドレス',
            imgUrl      : '/images/items/JR4-13.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-14',
            rare        : 'JR',
            name        : 'じゅんしんのゴールドジュエルシューズ',
            imgUrl      : '/images/items/JR4-14.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-15',
            rare        : 'JR',
            name        : 'じゅんしんのゴールドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR4-15.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'JR4-01',
            rare        : 'JR',
            name        : 'じゅんしんのブラックジュエルドレス',
            imgUrl      : '/images/items/JR4-01.png',
            numOwned    : { usual: 1, kira: 1 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-02',
            rare        : 'JR',
            name        : 'じゅんしんのブラックジュエルシューズ',
            imgUrl      : '/images/items/JR4-02.png',
            numOwned    : { usual: 1, kira: 1 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-03',
            rare        : 'JR',
            name        : 'じゅんしんのブラックジュエルヘアアクセ',
            imgUrl      : '/images/items/JR4-03.png',
            numOwned    : { usual: 1, kira: 1 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'JR4-19',
            rare        : 'JR',
            name        : 'じゅんしんのレッドジュエルドレス',
            imgUrl      : '/images/items/JR4-19.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-20',
            rare        : 'JR',
            name        : 'じゅんしんのレッドジュエルシューズ',
            imgUrl      : '/images/items/JR4-20.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-21',
            rare        : 'JR',
            name        : 'じゅんしんのレッドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR4-21.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'JR4-22',
            rare        : 'JR',
            name        : 'じゅんしんのグリーンジュエルドレス',
            imgUrl      : '/images/items/JR4-22.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-23',
            rare        : 'JR',
            name        : 'じゅんしんのグリーンジュエルシューズ',
            imgUrl      : '/images/items/JR4-23.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-24',
            rare        : 'JR',
            name        : 'じゅんしんのグリーンジュエルヘアアクセ',
            imgUrl      : '/images/items/JR4-24.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'JR4-25',
            rare        : 'JR',
            name        : 'じゅんしんのパープルジュエルドレス',
            imgUrl      : '/images/items/JR4-25.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-26',
            rare        : 'JR',
            name        : 'じゅんしんのパープルジュエルシューズ',
            imgUrl      : '/images/items/JR4-26.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-27',
            rare        : 'JR',
            name        : 'じゅんしんのパープルジュエルヘアアクセ',
            imgUrl      : '/images/items/JR4-27.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'JR4-28',
            rare        : 'JR',
            name        : 'じゅんしんのホワイトジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR4-28',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-29',
            rare        : 'JR',
            name        : 'じゅんしんのホワイトジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR4-29',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-30',
            rare        : 'JR',
            name        : 'じゅんしんのホワイトジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR4-30',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'JR4-31',
            rare        : 'JR',
            name        : 'じゅんしんのレインボージュエルドレス',
            imgUrl      : '/images/items/JR4-31.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'DS',
            type        : 'CO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-32',
            rare        : 'JR',
            name        : 'じゅんしんのレインボージュエルシューズ',
            imgUrl      : '/images/items/JR4-32.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'JR4-33',
            rare        : 'JR',
            name        : 'じゅんしんのレインボージュエルヘアアクセ',
            imgUrl      : '/images/items/JR4-33.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'JR',
          }),


          // [NOTE] JR5
          // ================================================================================

          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-04',
            rare        : 'JR',
            name        : 'しあわせのピンクジュエルドレス',
            imgUrl      : '/images/items/JR5-04.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-05',
            rare        : 'JR',
            name        : 'しあわせのピンクジュエルシューズ',
            imgUrl      : '/images/items/JR5-05.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-06',
            rare        : 'JR',
            name        : 'しあわせのピンクジュエルヘアアクセ',
            imgUrl      : '/images/items/JR5-06.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-07',
            rare        : 'JR',
            name        : 'しあわせのイエロージュエルドレス',
            imgUrl      : '/images/items/JR5-07.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-08',
            rare        : 'JR',
            name        : 'しあわせのイエロージュエルシューズ',
            imgUrl      : '/images/items/JR5-08.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-09',
            rare        : 'JR',
            name        : 'しあわせのイエロージュエルヘアアクセ',
            imgUrl      : '/images/items/JR5-09.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-10',
            rare        : 'JR',
            name        : 'しあわせのブルージュエルドレス',
            imgUrl      : '/images/items/JR5-10.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-11',
            rare        : 'JR',
            name        : 'しあわせのブルージュエルシューズ',
            imgUrl      : '/images/items/JR5-11.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-12',
            rare        : 'JR',
            name        : 'しあわせのブルージュエルヘアアクセ',
            imgUrl      : '/images/items/JR5-12.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-01',
            rare        : 'JR',
            name        : 'しあわせのゴールドジュエルドレス',
            imgUrl      : '/images/items/JR5-01.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-02',
            rare        : 'JR',
            name        : 'しあわせのゴールドジュエルシューズ',
            imgUrl      : '/images/items/JR5-02.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-03',
            rare        : 'JR',
            name        : 'しあわせのゴールドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR5-03.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-13',
            rare        : 'JR',
            name        : 'しあわせのブラックジュエルドレス',
            imgUrl      : '/images/items/JR5-13.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),

          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-14',
            rare        : 'JR',
            name        : 'しあわせのブラックジュエルシューズ',
            imgUrl      : '/images/items/JR5-14.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-15',
            rare        : 'JR',
            name        : 'しあわせのブラックジュエルヘアアクセ',
            imgUrl      : '/images/items/JR5-15.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-16',
            rare        : 'JR',
            name        : 'しあわせのレッドジュエルドレス',
            imgUrl      : '/images/items/JR5-16.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-17',
            rare        : 'JR',
            name        : 'しあわせのレッドジュエルシューズ',
            imgUrl      : '/images/items/JR5-17.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-18',
            rare        : 'JR',
            name        : 'しあわせのレッドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR5-18.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-19',
            rare        : 'JR',
            name        : 'しあわせのグリーンジュエルドレス',
            imgUrl      : '/images/items/JR5-19.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-20',
            rare        : 'JR',
            name        : 'しあわせのグリーンジュエルシューズ',
            imgUrl      : '/images/items/JR5-20.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-21',
            rare        : 'JR',
            name        : 'しあわせのグリーンジュエルヘアアクセ',
            imgUrl      : '/images/items/JR5-21.jpg',
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-22',
            rare        : 'JR',
            name        : 'しあわせのパープルジュエルドレス',
            imgUrl      : '/images/items/JR5-22.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-23',
            rare        : 'JR',
            name        : 'しあわせのパープルジュエルシューズ',
            imgUrl      : '/images/items/JR5-23.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-24',
            rare        : 'JR',
            name        : 'しあわせのパープルジュエルヘアアクセ',
            imgUrl      : '/images/items/JR5-24.jpg',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-25',
            rare        : 'JR',
            name        : 'しあわせのホワイトジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR5-25',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-26',
            rare        : 'JR',
            name        : 'しあわせのホワイトジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR5-26',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-27',
            rare        : 'JR',
            name        : 'しあわせのホワイトジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR5-27',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-28',
            rare        : 'JR',
            name        : 'しあわせのレインボージュエルドレス',
            imgUrl      : '/images/items/JR5-28.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-29',
            rare        : 'JR',
            name        : 'しあわせのレインボージュエルシューズ',
            imgUrl      : '/images/items/JR5-29.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'JR5-30',
            rare        : 'JR',
            name        : 'しあわせのレインボージュエルヘアアクセ',
            imgUrl      : '/images/items/JR5-30.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'JR',
          }),


          // [NOTE] RR
          // ================================================================================

          item({
            collection  : 'すずコレクション',
            id          : 'RR3-01',
            rare        : 'RR',
            name        : 'レインボーシンデレラワンピ',
            imgUrl      : '/images/items/RR3-01.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'RR3-02',
            rare        : 'RR',
            name        : 'レインボーシンデレラシューズ',
            imgUrl      : '/images/items/RR3-02.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'RR3-03',
            rare        : 'RR',
            name        : 'レインボーシンデレラヘアアクセ',
            imgUrl      : '/images/items/RR3-03.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'RR3-04',
            rare        : 'RR',
            name        : 'レインボープリンスワンピ',
            imgUrl      : '/images/items/RR3-04.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'RR3-05',
            rare        : 'RR',
            name        : 'レインボープリンスシューズ',
            imgUrl      : '/images/items/RR3-05.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'RR3-06',
            rare        : 'RR',
            name        : 'レインボープリンスヘアアクセ',
            imgUrl      : '/images/items/RR3-06.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'RR3-07',
            rare        : 'RR',
            name        : 'レインボースイートハニーワンピ',
            imgUrl      : '/images/items/RR3-07.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'RR3-08',
            rare        : 'RR',
            name        : 'レインボースイートハニーシューズ',
            imgUrl      : '/images/items/RR3-08.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'RR3-09',
            rare        : 'RR',
            name        : 'レインボースイートハニーヘアアクセ',
            imgUrl      : '/images/items/RR3-09.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'RR3-10',
            rare        : 'RR',
            name        : 'レインボーしらゆきひめワンピ',
            imgUrl      : '/images/items/RR3-10.png',
            numOwned    : { kira: 7 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'RR3-11',
            rare        : 'RR',
            name        : 'レインボーしらゆきひめシューズ',
            imgUrl      : '/images/items/RR3-11.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'RR3-12',
            rare        : 'RR',
            name        : 'レインボーしらゆきひめヘアアクセ',
            imgUrl      : '/images/items/RR3-12.png',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'RR3-13',
            rare        : 'RR',
            name        : 'レインボーアラビアンワンピ',
            imgUrl      : '/images/items/RR3-13.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'RR3-14',
            rare        : 'RR',
            name        : 'レインボーアラビアンシューズ',
            imgUrl      : '/images/items/RR3-14.png',
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'RR3-15',
            rare        : 'RR',
            name        : 'レインボーアラビアンヘアアクセ',
            imgUrl      : '/images/items/RR3-15.png',
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'RR3-16',
            rare        : 'RR',
            name        : 'レインボーガールズエールワンピ',
            imgUrl      : '/images/items/RR3-16.png',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'RR3-17',
            rare        : 'RR',
            name        : 'レインボーガールズエールシューズ',
            imgUrl      : '/images/items/RR3-17.png',
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'RR3-18',
            rare        : 'RR',
            name        : 'レインボーガールズエールヘアアクセ',
            imgUrl      : '/images/items/RR3-18.png',
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'RR',
          }),


          // [NOTE] HR
          // ================================================================================

          item({
            collection  : 'すずコレクション',
            id          : 'J3-01',
            rare        : 'HR',
            name        : 'シンデレラプリンセスブルーワンピ',
            imgUrl      : '/images/items/J3-01.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-02',
            rare        : 'HR',
            name        : 'シンデレラプリンセスブルーシューズ',
            imgUrl      : '/images/items/J3-02.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-03',
            rare        : 'HR',
            name        : 'シンデレラプリンセスブルーヘアアクセ',
            imgUrl      : '/images/items/J3-03.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'J3-04',
            rare        : 'HR',
            name        : 'シンデレラプリンスブルーワンピ',
            imgUrl      : '/images/items/J3-04.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-05',
            rare        : 'HR',
            name        : 'シンデレラプリンスブルーシューズ',
            imgUrl      : '/images/items/J3-05.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-06',
            rare        : 'HR',
            name        : 'シンデレラプリンスブルーヘアアクセ',
            imgUrl      : '/images/items/J3-06.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-73',
            rare        : 'HR',
            name        : 'シンデレラプリンセスピンクワンピ',
            imgUrl      : '/images/items/J3-73.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-74',
            rare        : 'HR',
            name        : 'シンデレラプリンセスピンクシューズ',
            imgUrl      : '/images/items/J3-74.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-75',
            rare        : 'HR',
            name        : 'シンデレラプリンセスピンクヘアアクセ',
            imgUrl      : '/images/items/J3-75.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-76',
            rare        : 'HR',
            name        : 'シンデレラプリンスピンクワンピ',
            imgUrl      : '/images/items/J3-76.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-77',
            rare        : 'HR',
            name        : 'シンデレラプリンスピンクシューズ',
            imgUrl      : '/images/items/J3-77.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-78',
            rare        : 'HR',
            name        : 'シンデレラプリンスピンクヘアアクセ',
            imgUrl      : '/images/items/J3-78.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'HR',
          }),


          externalItem(itemsPromo2019Events, 'P-107', { collection: 'リングマリィコレクション' }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'P-108',
            rare        : 'HR',
            name        : 'シンデレラプリンスオレンジシューズ',
            imgUrl      : '/images/items/P-108.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          externalItem(itemsPromo2019Events, 'P-109', { collection: 'リングマリィコレクション' }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'HR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'すずコレクション',
            id          : 'J3-07',
            rare        : 'PR',
            name        : 'ダンスパンサーワンピ',
            imgUrl      : '/images/items/J3-07.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-08',
            rare        : 'PR',
            name        : 'ダンスパンサーシューズ',
            imgUrl      : '/images/items/J3-08.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-09',
            rare        : 'PR',
            name        : 'ダンスパンサーヘアアクセ',
            imgUrl      : '/images/items/J3-09.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'PR',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'J3-10',
            rare        : 'PR',
            name        : 'ひまわりスマイルピンクトップス',
            imgUrl      : '/images/items/J3-10.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-11',
            rare        : 'PR',
            name        : 'ひまわりスマイルピンクスカート',
            imgUrl      : '/images/items/J3-11.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-12',
            rare        : 'PR',
            name        : 'ひまわりスマイルピンクシューズ',
            imgUrl      : '/images/items/J3-12.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-13',
            rare        : 'PR',
            name        : 'ひまわりスマイルピンクヘアアクセ',
            imgUrl      : '/images/items/J3-13.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'J3-14',
            rare        : 'PR',
            name        : 'ひまわりスマイルミントトップス',
            imgUrl      : '/images/items/J3-14.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-15',
            rare        : 'PR',
            name        : 'ひまわりスマイルミントスカート',
            imgUrl      : '/images/items/J3-15.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-16',
            rare        : 'PR',
            name        : 'ひまわりスマイルミントシューズ',
            imgUrl      : '/images/items/J3-16.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-17',
            rare        : 'PR',
            name        : 'ひまわりスマイルミントヘアアクセ',
            imgUrl      : '/images/items/J3-17.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-79',
            rare        : 'PR',
            name        : 'ジャンピンラビッツキューティートップス',
            imgUrl      : '/images/items/J3-79.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-80',
            rare        : 'PR',
            name        : 'ジャンピンラビッツキューティースカート',
            imgUrl      : '/images/items/J3-80.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-81',
            rare        : 'PR',
            name        : 'ジャンピンラビッツキューティーシューズ',
            imgUrl      : '/images/items/J3-81.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-82',
            rare        : 'PR',
            name        : 'ジャンピンラビッツキューティーヘアアクセ',
            imgUrl      : '/images/items/J3-82.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-83',
            rare        : 'PR',
            name        : 'ジャンピンラビッツクールトップス',
            imgUrl      : '/images/items/J3-83.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-84',
            rare        : 'PR',
            name        : 'ジャンピンラビッツクールパンツ',
            imgUrl      : '/images/items/J3-84.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-85',
            rare        : 'PR',
            name        : 'ジャンピンラビッツクールシューズ',
            imgUrl      : '/images/items/J3-85.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-86',
            rare        : 'PR',
            name        : 'ジャンピンラビッツクールヘアアクセ',
            imgUrl      : '/images/items/J3-86.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-87',
            rare        : 'PR',
            name        : 'ダンスパンサーレッドワンピ',
            imgUrl      : '/images/items/J3-87.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-88',
            rare        : 'PR',
            name        : 'ダンスパンサーレッドシューズ',
            imgUrl      : '/images/items/J3-88.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-89',
            rare        : 'PR',
            name        : 'ダンスパンサーレッドヘアアクセ',
            imgUrl      : '/images/items/J3-89.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'PR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-90',
            rare        : 'PR',
            name        : 'ひまわりスマイルブルートップス',
            imgUrl      : '/images/items/J3-90.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-91',
            rare        : 'PR',
            name        : 'ひまわりスマイルブルースカート',
            imgUrl      : '/images/items/J3-91.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-92',
            rare        : 'PR',
            name        : 'ひまわりスマイルブルーシューズ',
            imgUrl      : '/images/items/J3-92.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-93',
            rare        : 'PR',
            name        : 'ひまわりスマイルブルーヘアアクセ',
            imgUrl      : '/images/items/J3-93.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] PR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-25',
            rare        : 'PR',
            name        : 'ひまわりスマイルパープルトップス',
            imgUrl      : '/images/items/MF-25.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-26',
            rare        : 'PR',
            name        : 'ひまわりスマイルパープルスカート',
            imgUrl      : '/images/items/MF-26.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-27',
            rare        : 'PR',
            name        : 'ひまわりスマイルパープルシューズ',
            imgUrl      : '/images/items/MF-27.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-28',
            rare        : 'PR',
            name        : 'ひまわりスマイルパープルヘアアクセ',
            imgUrl      : '/images/items/MF-28.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'すずコレクション',
            id          : 'J3-18',
            rare        : 'SR',
            name        : 'フラワーパレオヒヤシンストップス',
            imgUrl      : '/images/items/J3-18.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-19',
            rare        : 'SR',
            name        : 'フラワーパレオヒヤシンススカート',
            imgUrl      : '/images/items/J3-19.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-20',
            rare        : 'SR',
            name        : 'フラワーパレオヒヤシンスシューズ',
            imgUrl      : '/images/items/J3-20.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-21',
            rare        : 'SR',
            name        : 'フラワーパレオヒヤシンスヘアアクセ',
            imgUrl      : '/images/items/J3-21.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'J3-22',
            rare        : 'SR',
            name        : 'かいがらゆかたピンクトップス',
            imgUrl      : '/images/items/J3-22.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-23',
            rare        : 'SR',
            name        : 'かいがらゆかたピンクスカート',
            imgUrl      : '/images/items/J3-23.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-24',
            rare        : 'SR',
            name        : 'かいがらゆかたピンクシューズ',
            imgUrl      : '/images/items/J3-24.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-25',
            rare        : 'SR',
            name        : 'かいがらゆかたピンクヘアアクセ',
            imgUrl      : '/images/items/J3-25.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'J3-26',
            rare        : 'SR',
            name        : 'カラフルクッキングベリートップス',
            imgUrl      : '/images/items/J3-26.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-27',
            rare        : 'SR',
            name        : 'カラフルクッキングベリースカート',
            imgUrl      : '/images/items/J3-27.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-28',
            rare        : 'SR',
            name        : 'カラフルクッキングベリーシューズ',
            imgUrl      : '/images/items/J3-28.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-29',
            rare        : 'SR',
            name        : 'カラフルクッキングベリーヘアアクセ',
            imgUrl      : '/images/items/J3-29.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'PP5-04',
            rare        : 'SR',
            name        : 'プリパラ5しゅうねんみれぃワンピ',
            imgUrl      : '/images/items/PP5-04.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'PP5-05',
            rare        : 'SR',
            name        : 'プリパラ5しゅうねんみれぃシューズ',
            imgUrl      : '/images/items/PP5-05.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'PP5-06',
            rare        : 'SR',
            name        : 'プリパラ5しゅうねんみれぃヘアアクセ',
            imgUrl      : '/images/items/PP5-06.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'SR',
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-94',
            rare        : 'SR',
            name        : 'ワイルドスタートップス',
            imgUrl      : '/images/items/J3-94.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-95',
            rare        : 'SR',
            name        : 'ワイルドスタースカート',
            imgUrl      : '/images/items/J3-95.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-96',
            rare        : 'SR',
            name        : 'ワイルドスターサンダル',
            imgUrl      : '/images/items/J3-96.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-97',
            rare        : 'SR',
            name        : 'ワイルドスターヘアアクセ',
            imgUrl      : '/images/items/J3-97.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-98',
            rare        : 'SR',
            name        : 'カラフルクッキングアクアトップス',
            imgUrl      : '/images/items/J3-98.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-99',
            rare        : 'SR',
            name        : 'カラフルクッキングアクアスカート',
            imgUrl      : '/images/items/J3-99.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-100',
            rare        : 'SR',
            name        : 'カラフルクッキングアクアシューズ',
            imgUrl      : '/images/items/J3-100.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-101',
            rare        : 'SR',
            name        : 'カラフルクッキングアクアヘアアクセ',
            imgUrl      : '/images/items/J3-101.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'PP5-07',
            rare        : 'SR',
            name        : 'プリパラ５しゅうねんそふぃワンピ',
            imgUrl      : '/images/items/PP5-07.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'PP5-08',
            rare        : 'SR',
            name        : 'プリパラ５しゅうねんそふぃシューズ',
            imgUrl      : '/images/items/PP5-08.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'PP5-09',
            rare        : 'SR',
            name        : 'プリパラ５しゅうねんそふぃヘアアクセ',
            imgUrl      : '/images/items/PP5-09.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            rare        : 'SR',
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'すずコレクション',
            id          : 'J3-31',
            rare        : 'R',
            name        : 'クーリッシュブルゾン＆ロンT',
            imgUrl      : '/images/items/J3-31.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-32',
            rare        : 'R',
            name        : 'クーリッシュスニーカー',
            imgUrl      : '/images/items/J3-32.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-33',
            rare        : 'R',
            name        : 'クーリッシュヘアアクセ',
            imgUrl      : '/images/items/J3-33.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            rare        : 'R',
          }),


          item({
            collection  : 'すずコレクション',
            id          : 'J3-34',
            rare        : 'R',
            name        : 'ディアクラウンユニフォームブラックトップス',
            imgUrl      : '/images/items/J3-34.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-35',
            rare        : 'R',
            name        : 'ディアクラウンユニフォームブラックスカート',
            imgUrl      : '/images/items/J3-35.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-36',
            rare        : 'R',
            name        : 'ディアクラウンユニフォームブラックシューズ',
            imgUrl      : '/images/items/J3-36.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずコレクション',
            id          : 'J3-37',
            rare        : 'R',
            name        : 'ディアクラウンユニフォームブラックヘアアクセ',
            imgUrl      : '/images/items/J3-37.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-103',
            rare        : 'R',
            name        : 'えきちょうさんトップス',
            imgUrl      : '/images/items/J3-103.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-104',
            rare        : 'R',
            name        : 'えきちょうさんスカート',
            imgUrl      : '/images/items/J3-104.png',
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-105',
            rare        : 'R',
            name        : 'えきちょうさんシューズ',
            imgUrl      : '/images/items/J3-105.png',
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-106',
            rare        : 'R',
            name        : 'えきちょうさんヘアアクセ',
            imgUrl      : '/images/items/J3-106.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-107',
            rare        : 'R',
            name        : 'ディアクラウンユニフォームゴールドトップス',
            imgUrl      : '/images/items/J3-107.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-108',
            rare        : 'R',
            name        : 'ディアクラウンユニフォームゴールドスカート',
            imgUrl      : '/images/items/J3-108.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-109',
            rare        : 'R',
            name        : 'ディアクラウンユニフォームゴールドシューズ',
            imgUrl      : '/images/items/J3-109.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-110',
            rare        : 'R',
            name        : 'ディアクラウンユニフォームゴールドヘアアクセ',
            imgUrl      : '/images/items/J3-110.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J3-38',
            rare        : 'R',
            name        : 'ハッピースウィムビビッドワンピ',
            imgUrl      : '/images/items/J3-38.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-39',
            rare        : 'R',
            name        : 'ハッピースウィムビビッドシューズ',
            imgUrl      : '/images/items/J3-39.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-40',
            rare        : 'R',
            name        : 'ハッピースウィムビビッドヘアアクセ',
            imgUrl      : '/images/items/J3-40.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'R',
          }),


          item({
            collection  : '共通',
            id          : 'J3-41',
            rare        : 'R',
            name        : 'スターダストレザーエメラルドトップス',
            imgUrl      : '/images/items/J3-41.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-42',
            rare        : 'R',
            name        : 'スターダストレザーエメラルドスカート',
            imgUrl      : '/images/items/J3-42.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-43',
            rare        : 'R',
            name        : 'スターダストレザーエメラルドブーツ',
            imgUrl      : '/images/items/J3-43.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-44',
            rare        : 'R',
            name        : 'スターダストレザーエメラルドヘアアクセ',
            imgUrl      : '/images/items/J3-44.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J3-45',
            rare        : 'R',
            name        : 'ドレッシーストライプパープルトップス',
            imgUrl      : '/images/items/J3-45.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-46',
            rare        : 'R',
            name        : 'ドレッシーストライプパープルスカート',
            imgUrl      : '/images/items/J3-46.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-47',
            rare        : 'R',
            name        : 'ドレッシーストライプパープルシューズ',
            imgUrl      : '/images/items/J3-47.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-48',
            rare        : 'R',
            name        : 'ドレッシーストライプパープルヘアアクセ',
            imgUrl      : '/images/items/J3-48.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J3-49',
            rare        : 'R',
            name        : 'マドモアゼルマリンブルーワンピ',
            imgUrl      : '/images/items/J3-49.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-50',
            rare        : 'R',
            name        : 'マドモアゼルマリンブルーシューズ',
            imgUrl      : '/images/items/J3-50.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-51',
            rare        : 'R',
            name        : 'マドモアゼルマリンブルーヘアアクセ',
            imgUrl      : '/images/items/J3-51.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'J3-54',
            rare        : 'N',
            name        : 'ポップコーンショップピンクトップス',
            imgUrl      : '/images/items/J3-54.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-55',
            rare        : 'N',
            name        : 'ポップコーンショップピンクパンツ',
            imgUrl      : '/images/items/J3-55.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-56',
            rare        : 'N',
            name        : 'ポップコーンショップピンクシューズ',
            imgUrl      : '/images/items/J3-56.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-57',
            rare        : 'N',
            name        : 'ポップコーンショップピンクヘアアクセ',
            imgUrl      : '/images/items/J3-57.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J3-58',
            rare        : 'N',
            name        : 'サマーフローラルブラウス',
            imgUrl      : '/images/items/J3-58.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-59',
            rare        : 'N',
            name        : 'サマーフローラルプリーツスカート',
            imgUrl      : '/images/items/J3-59.png',
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-60',
            rare        : 'N',
            name        : 'サマーフローラルパンプス',
            imgUrl      : '/images/items/J3-60.png',
            numOwned    : { usual: 8 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-61',
            rare        : 'N',
            name        : 'サマーフローラルヘアアクセ',
            imgUrl      : '/images/items/J3-61.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : 'すずコレクション',
            id          : 'J3-30',
            rare        : 'SR',
            name        : 'みずいろみずでっぽう',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J3-30.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フォロトモポイント',
            id          : 'J3-127',
            rare        : 'SR',
            name        : 'イエローみずでっぽう',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J3-127.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'リングマリィコレクション',
            id          : 'J3-102',
            rare        : 'SR',
            name        : 'おおきなひまわり',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J3-102.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'J3-114',
            rare        : 'SR',
            name        : 'すみっコぐらしぺんぎん？',
            imgUrl      : '/images/items/J3-114.png',
            kind        : 'パシャッとアイテム',
            color       : '緑',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-52',
            rare        : 'R',
            name        : 'キラッＣＨＵのおめん',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J3-52.png',
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J3-53',
            rare        : 'R',
            name        : 'トロピカルサンデーブルーハワイあじ',
            kind        : 'パシャッとアイテム',
            imgUrl      : '/images/items/J3-53.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '共通',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] ブランドランク
          // ================================================================================

          item({
            collection  : 'ブランドランク',
            id          : 'DS-01',
            rare        : 'R',
            name        : 'クーリッシュブルゾン＆ブルーロンT',
            imgUrl      : '/images/items/DS-01.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'DS-02',
            rare        : 'R',
            name        : 'クーリッシュブラックスニーカー',
            imgUrl      : '/images/items/DS-02.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'DS-03',
            rare        : 'R',
            name        : 'クーリッシュオレンジヘアアクセ',
            imgUrl      : '/images/items/DS-03.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
          }),


          item({
            collection  : 'ブランドランク',
            id          : 'CH-04',
            rare        : 'R',
            name        : 'サマーフローラルパステルブラウス',
            imgUrl      : '/images/items/CH-04.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'CH-05',
            rare        : 'R',
            name        : 'サマーフローラルパステルプリーツスカート',
            imgUrl      : '/images/items/CH-05.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'CH-06',
            rare        : 'R',
            name        : 'サマーフローラルパステルパンプス',
            imgUrl      : '/images/items/CH-06.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'CH-07',
            rare        : 'R',
            name        : 'サマーフローラルパステルヘアアクセ',
            imgUrl      : '/images/items/CH-07.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プレゼントボックス
          // ================================================================================

          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-11',
            rare        : 'SR',
            name        : 'オムライスケチャップワンピ',
            imgUrl      : '/images/items/PB-11.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-12',
            rare        : 'SR',
            name        : 'オムライスケチャップシューズ',
            imgUrl      : '/images/items/PB-12.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-13',
            rare        : 'SR',
            name        : 'オムライスケチャップヘアアクセ',
            imgUrl      : '/images/items/PB-13.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-14',
            rare        : 'SR',
            name        : 'スタークールマリンワンピ',
            imgUrl      : '/images/items/PB-14.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-15',
            rare        : 'SR',
            name        : 'スタークールマリンシューズ',
            imgUrl      : '/images/items/PB-15.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-16',
            rare        : 'SR',
            name        : 'スタークールマリンヘアアクセ',
            imgUrl      : '/images/items/PB-16.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
          }),


          // [NOTE] サマースクラッチ
          // ================================================================================

          item({
            collection  : 'サマースクラッチ',
            id          : 'SC3-01',
            rare        : 'R',
            name        : 'ハイビスカスサマーセパレート',
            imgUrl      : '/images/items/SC3-01.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'サマースクラッチ',
            id          : 'SC3-02',
            rare        : 'R',
            name        : 'サマーマリンカジュアルサンダル',
            imgUrl      : '/images/items/SC3-02.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'サマースクラッチ',
            id          : 'SC3-03',
            rare        : 'R',
            name        : 'ボヤージュヘアアクセ',
            imgUrl      : '/images/items/SC3-03.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'サマースクラッチ',
            rare        : 'R',
          }),


          item({
            collection  : 'サマースクラッチ',
            id          : 'SC3-04',
            rare        : 'R',
            name        : 'ハワイアンアロハトップス',
            imgUrl      : '/images/items/SC3-04.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'サマースクラッチ',
            id          : 'SC3-05',
            rare        : 'R',
            name        : 'ハワイアンアロハスカート',
            imgUrl      : '/images/items/SC3-05.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'サマースクラッチ',
            id          : 'SC3-06',
            rare        : 'R',
            name        : 'ハワイアンアロハシューズ',
            imgUrl      : '/images/items/SC3-06.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'サマースクラッチ',
            id          : 'SC3-07',
            rare        : 'R',
            name        : 'ハワイアンアロハヘアアクセ',
            imgUrl      : '/images/items/SC3-07.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ジュエルパクト
          // ================================================================================

          externalItem(itemsPromo2019Pact, 'JP-065', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-066', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-067', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-068', { collection: 'ジュエルパクト' }),


          externalItem(itemsPromo2019Pact, 'JP-097', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-098', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-099', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-100', { collection: 'ジュエルパクト' }),


          externalItem(itemsPromo2019Pact, 'JP-101', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-102', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-103', { collection: 'ジュエルパクト' }),
          item({ rare: 'SR', collection: 'ジュエルパクト' }),


          externalItem(itemsPromo2019Pact, 'JP-104', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-105', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-106', { collection: 'ジュエルパクト' }),
          item({ rare: 'SR', collection: 'ジュエルパクト' }),


          externalItem(itemsPromo2019Pact, 'JP-114', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-115', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-116', { collection: 'ジュエルパクト' }),
          item({ rare: 'SR', collection: 'ジュエルパクト' }),


          // [NOTE] デザインパレット自作
          // ================================================================================

          item({
            collection  : 'デザインパレット自作',
            id          : 'DP-SM-HP-01',
            rare        : 'SR',
            name        : 'はあと♡パール型①',
            imgUrl      : '/images/items/DPKG-05.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'デザインパレット自作',
            id          : 'DP-SM-RV-01',
            rare        : 'SR',
            name        : 'ロゼットビーナス型①',
            imgUrl      : '/images/items/DPKG-08.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'デザインパレット自作',
            id          : 'DP-SM-MA-01',
            rare        : 'SR',
            name        : 'もこもこアニマル型①',
            imgUrl      : '/images/items/DPKG-04.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'デザインパレット自作',
            id          : 'DP-SM-MA-02',
            rare        : 'SR',
            name        : 'もこもこアニマル型②',
            imgUrl      : '/images/items/DPKG-04.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ファントミラージュチャンネル
          // ================================================================================

          item({
            collection  : 'ファントミラージュチャンネル',
            id          : 'J3-62',
            rare        : 'SR',
            name        : 'ファントミダイヤセイラワンピ',
            imgUrl      : '/images/items/J3-62.png',
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファントミラージュチャンネル',
            id          : 'J3-63',
            rare        : 'SR',
            name        : 'ファントミダイヤセイラシューズ',
            imgUrl      : '/images/items/J3-63.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファントミラージュチャンネル',
            id          : 'J3-64',
            rare        : 'SR',
            name        : 'ファントミダイヤセイラヘアアクセ',
            imgUrl      : '/images/items/J3-64.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファントミラージュチャンネル',
            rare        : 'SR',
          }),


          // [NOTE] すみっコぐらしチャンネル
          // ================================================================================

          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'J3-111',
            rare        : 'SR',
            name        : 'すみっコぐらしぺんぺんアイスクリームワンピ',
            imgUrl      : '/images/items/J3-111.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'J3-112',
            rare        : 'SR',
            name        : 'すみっコぐらしぺんぺんアイスクリームシューズ',
            imgUrl      : '/images/items/J3-112.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'J3-113',
            rare        : 'SR',
            name        : 'すみっコぐらしとかげヘアアクセ',
            imgUrl      : '/images/items/J3-113.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'SR',
          }),


          // [NOTE] かいがらゆかたチャンネル
          // ================================================================================

          item({
            collection  : 'かいがらゆかたチャンネル',
            id          : 'J3-65',
            rare        : 'SR',
            name        : 'かいがらゆかたクリームトップス',
            imgUrl      : '/images/items/J3-65.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'かいがらゆかたチャンネル',
            id          : 'J3-66',
            rare        : 'SR',
            name        : 'かいがらゆかたクリームスカート',
            imgUrl      : '/images/items/J3-66.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'かいがらゆかたチャンネル',
            id          : 'J3-67',
            rare        : 'SR',
            name        : 'かいがらゆかたクリームシューズ',
            imgUrl      : '/images/items/J3-67.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'かいがらゆかたチャンネル',
            id          : 'J3-68',
            rare        : 'SR',
            name        : 'かいがらゆかたクリームヘアアクセ',
            imgUrl      : '/images/items/J3-68.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'かいがらゆかたチャンネル',
            id          : 'J3-69',
            rare        : 'SR',
            name        : 'かいがらゆかたライムトップス',
            imgUrl      : '/images/items/J3-69.png',
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'かいがらゆかたチャンネル',
            id          : 'J3-70',
            rare        : 'SR',
            name        : 'かいがらゆかたライムスカート',
            imgUrl      : '/images/items/J3-70.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'かいがらゆかたチャンネル',
            id          : 'J3-71',
            rare        : 'SR',
            name        : 'かいがらゆかたライムシューズ',
            imgUrl      : '/images/items/J3-71.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'かいがらゆかたチャンネル',
            id          : 'J3-72',
            rare        : 'SR',
            name        : 'かいがらゆかたライムヘアアクセ',
            imgUrl      : '/images/items/J3-72.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] フラワーパレオチャンネル
          // ================================================================================

          item({
            collection  : 'フラワーパレオチャンネル',
            id          : 'J3-115',
            rare        : 'SR',
            name        : 'フラワーパレオブルースタートップス',
            imgUrl      : '/images/items/J3-115.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フラワーパレオチャンネル',
            id          : 'J3-116',
            rare        : 'SR',
            name        : 'フラワーパレオブルースタースカート',
            imgUrl      : '/images/items/J3-116.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フラワーパレオチャンネル',
            id          : 'J3-117',
            rare        : 'SR',
            name        : 'フラワーパレオブルースターシューズ',
            imgUrl      : '/images/items/J3-117.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フラワーパレオチャンネル',
            id          : 'J3-118',
            rare        : 'SR',
            name        : 'フラワーパレオブルースターヘアアクセ',
            imgUrl      : '/images/items/J3-118.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'フラワーパレオチャンネル',
            id          : 'J3-119',
            rare        : 'SR',
            name        : 'フラワーパレオミモザトップス',
            imgUrl      : '/images/items/J3-119.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フラワーパレオチャンネル',
            id          : 'J3-120',
            rare        : 'SR',
            name        : 'フラワーパレオミモザスカート',
            imgUrl      : '/images/items/J3-120.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フラワーパレオチャンネル',
            id          : 'J3-121',
            rare        : 'SR',
            name        : 'フラワーパレオミモザシューズ',
            imgUrl      : '/images/items/J3-121.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フラワーパレオチャンネル',
            id          : 'J3-122',
            rare        : 'SR',
            name        : 'フラワーパレオミモザヘアアクセ',
            imgUrl      : '/images/items/J3-122.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] すずのワイルドスターチャンネル
          // ================================================================================

          item({
            collection  : 'すずのワイルドスターチャンネル',
            id          : 'J3-123',
            rare        : 'SR',
            name        : 'ワイルドスターイエロートップス',
            imgUrl      : '/images/items/J3-123.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずのワイルドスターチャンネル',
            id          : 'J3-124',
            rare        : 'SR',
            name        : 'ワイルドスターイエロースカート',
            imgUrl      : '/images/items/J3-124.png',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずのワイルドスターチャンネル',
            id          : 'J3-125',
            rare        : 'SR',
            name        : 'ワイルドスターイエローシューズ',
            imgUrl      : '/images/items/J3-125.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すずのワイルドスターチャンネル',
            id          : 'J3-126',
            rare        : 'SR',
            name        : 'ワイルドスターイエローヘアアクセ',
            imgUrl      : '/images/items/J3-126.png',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリパラ5しゅうねんチャンネル
          // ================================================================================

          item({
            collection  : 'プリパラ5しゅうねんチャンネル',
            id          : 'PP5-01',
            rare        : 'SR',
            name        : 'プリパラ5しゅうねんらぁらワンピ',
            imgUrl      : '/images/items/PP5-01.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねんチャンネル',
            id          : 'PP5-02',
            rare        : 'SR',
            name        : 'プリパラ5しゅうねんらぁらシューズ',
            imgUrl      : '/images/items/PP5-02.png',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねんチャンネル',
            id          : 'PP5-03',
            rare        : 'SR',
            name        : 'プリパラ5しゅうねんらぁらヘアアクセ',
            imgUrl      : '/images/items/PP5-03.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねんチャンネル',
            rare        : 'SR',
          }),


          // [NOTE] プリパラ5しゅうねん福袋その1
          // ================================================================================

          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-01',
            rare        : 'PR',
            name        : 'スーパーサイリウムらぁらアナザーワンピ',
            imgUrl      : '/images/items/SLJ3-01.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-02',
            rare        : 'PR',
            name        : 'スーパーサイリウムらぁらアナザーシューズ',
            imgUrl      : '/images/items/SLJ3-02.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-03',
            rare        : 'PR',
            name        : 'スーパーサイリウムらぁらアナザーヘアアクセ',
            imgUrl      : '/images/items/SLJ3-03.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            rare        : 'PR',
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-04',
            rare        : 'SR',
            name        : 'らぁらふゆせいふく',
            imgUrl      : '/images/items/SLJ3-04.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-05',
            rare        : 'SR',
            name        : 'らぁらふゆローファー',
            imgUrl      : '/images/items/SLJ3-05.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-06',
            rare        : 'SR',
            name        : 'トゥインクルリボンサイリウムヘアアクセ',
            imgUrl      : '/images/items/SLJ3-06.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-07',
            rare        : 'SR',
            name        : 'わたあめふわふわトップス',
            imgUrl      : '/images/items/SLJ3-07.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-08',
            rare        : 'SR',
            name        : 'わたあめふわふわシューズ',
            imgUrl      : '/images/items/SLJ3-08.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-09',
            rare        : 'SR',
            name        : 'わたあめふわふわスカート',
            imgUrl      : '/images/items/SLJ3-09.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-10',
            rare        : 'SR',
            name        : 'カップケーキヘアアクセ',
            imgUrl      : '/images/items/SLJ3-10.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-11',
            rare        : 'SR',
            name        : 'ウィッシュリボンアイドルブラウスS',
            imgUrl      : '/images/items/SLJ3-11.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-12',
            rare        : 'SR',
            name        : 'ウィッシュリボンアイドルスカートS',
            imgUrl      : '/images/items/SLJ3-12.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-13',
            rare        : 'SR',
            name        : 'ウィッシュリボンアイドルブーツS',
            imgUrl      : '/images/items/SLJ3-13.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-14',
            rare        : 'SR',
            name        : 'ウィッシュリボンアイドルヘアアクセS',
            imgUrl      : '/images/items/SLJ3-14.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-15',
            rare        : 'SR',
            name        : 'カンペキサマー☆アドベンチャートップス',
            imgUrl      : '/images/items/SLJ3-15.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,

          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-16',
            rare        : 'SR',
            name        : 'カンペキサマー☆アドベンチャーパンツ',
            imgUrl      : '/images/items/SLJ3-16.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,

          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-17',
            rare        : 'SR',
            name        : 'カンペキサマー☆アドベンチャーシューズ',
            imgUrl      : '/images/items/SLJ3-17.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,

          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-18',
            rare        : 'SR',
            name        : 'カンペキサマー☆アドベンチャーヘアアクセ',
            imgUrl      : '/images/items/SLJ3-18.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,

          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-19',
            rare        : 'SR',
            name        : 'アイドルけんじジャケット',
            imgUrl      : '/images/items/SLJ3-19.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-20',
            rare        : 'SR',
            name        : 'アイドルけんじパンツ',
            imgUrl      : '/images/items/SLJ3-20.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-21',
            rare        : 'SR',
            name        : 'アイドルけんじシューズ',
            imgUrl      : '/images/items/SLJ3-21.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-22',
            rare        : 'SR',
            name        : 'アイドルけんじヘアアクセ',
            imgUrl      : '/images/items/SLJ3-22.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-23',
            rare        : 'SR',
            name        : 'スタースプラッシュマリンワンピ',
            imgUrl      : '/images/items/SLJ3-23.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-24',
            rare        : 'SR',
            name        : 'スタースプラッシュマリンシューズ',
            imgUrl      : '/images/items/SLJ3-24.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-25',
            rare        : 'SR',
            name        : 'スタースプラッシュマリンヘアアクセ',
            imgUrl      : '/images/items/SLJ3-25.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-26',
            rare        : 'SR',
            name        : 'レインボーブルースマイルトップス',
            imgUrl      : '/images/items/SLJ3-26.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-27',
            rare        : 'SR',
            name        : 'レインボーブルースマイルスカート',
            imgUrl      : '/images/items/SLJ3-27.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-28',
            rare        : 'SR',
            name        : 'レインボーブルースマイルシューズ',
            imgUrl      : '/images/items/SLJ3-28.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-29',
            rare        : 'SR',
            name        : 'レインボーブルースマイルヘアアクセ',
            imgUrl      : '/images/items/SLJ3-29.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-30',
            rare        : 'SR',
            name        : 'ラブリーメイクコフレトップス',
            imgUrl      : '/images/items/SLJ3-30.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-31',
            rare        : 'SR',
            name        : 'ラブリーメイクコフレドレス',
            imgUrl      : '/images/items/SLJ3-31.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-32',
            rare        : 'SR',
            name        : 'ラブリーメイクコフレシューズ',
            imgUrl      : '/images/items/SLJ3-32.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-33',
            rare        : 'SR',
            name        : 'ノワールドットピュアヘアアクセ',
            imgUrl      : '/images/items/SLJ3-33.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-34',
            rare        : 'SR',
            name        : 'スターライトユニコトップス',
            imgUrl      : '/images/items/SLJ3-34.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-35',
            rare        : 'SR',
            name        : 'スターライトユニコパンツ',
            imgUrl      : '/images/items/SLJ3-35.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-36',
            rare        : 'SR',
            name        : 'スターライトユニコシューズ',
            imgUrl      : '/images/items/SLJ3-36.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その1',
            id          : 'SLJ3-37',
            rare        : 'SR',
            name        : 'ゆめかわレインボーオリーブヘアアクセ',
            imgUrl      : '/images/items/SLJ3-37.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリパラ5しゅうねん福袋その2
          // ================================================================================

          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-38',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムみれぃアナザーワンピ',
            imgUrl      : '/images/items/SLJ3-38.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-39',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムみれぃアナザーシューズ',
            imgUrl      : '/images/items/SLJ3-39.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-40',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムみれぃアナザーヘアアクセ',
            imgUrl      : '/images/items/SLJ3-40.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            rare        : 'PR',
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-41',
            rare        : 'SR',
            name        : 'みれぃふゆせいふく',
            imgUrl      : '/images/items/SLJ3-41.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-42',
            rare        : 'SR',
            name        : 'みれぃふゆローファー',
            imgUrl      : '/images/items/SLJ3-42.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-43',
            rare        : 'SR',
            name        : 'いはんチケット200ゴールドヘアアクセ',
            imgUrl      : '/images/items/SLJ3-43.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-44',
            rare        : 'SR',
            name        : 'パイレーツレディワンピ',
            imgUrl      : '/images/items/SLJ3-44.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-45',
            rare        : 'SR',
            name        : 'パイレーツレディシューズ',
            imgUrl      : '/images/items/SLJ3-45.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-46',
            rare        : 'SR',
            name        : 'パイレーツレディヘアアクセ',
            imgUrl      : '/images/items/SLJ3-46.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-47',
            rare        : 'SR',
            name        : 'ドリームハートレースブラウスS',
            imgUrl      : '/images/items/SLJ3-47.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-48',
            rare        : 'SR',
            name        : 'ドリームハートレーススカートS',
            imgUrl      : '/images/items/SLJ3-48.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-49',
            rare        : 'SR',
            name        : 'ドリームハートレースシューズS',
            imgUrl      : '/images/items/SLJ3-49.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-50',
            rare        : 'SR',
            name        : 'ドリームハートレースヘアアクセS',
            imgUrl      : '/images/items/SLJ3-50.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-51',
            rare        : 'SR',
            name        : 'ニコニコ！サプライズ☆パーティートップス',
            imgUrl      : '/images/items/SLJ3-51.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-52',
            rare        : 'SR',
            name        : 'ニコニコ！サプライズ☆パーティースカート',
            imgUrl      : '/images/items/SLJ3-52.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-53',
            rare        : 'SR',
            name        : 'ニコニコ！サプライズ☆パーティーシューズ',
            imgUrl      : '/images/items/SLJ3-53.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-54',
            rare        : 'SR',
            name        : 'サプライズ☆パーティーヘアアクセ',
            imgUrl      : '/images/items/SLJ3-54.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-55',
            rare        : 'SR',
            name        : 'ダイヤチェックビビッドトップス',
            imgUrl      : '/images/items/SLJ3-55.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-56',
            rare        : 'SR',
            name        : 'ダイヤチェックビビッドスカート',
            imgUrl      : '/images/items/SLJ3-56.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-57',
            rare        : 'SR',
            name        : 'ダイヤチェックビビッドシューズ',
            imgUrl      : '/images/items/SLJ3-57.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-58',
            rare        : 'SR',
            name        : 'ダイヤチェックビビッドヘアアクセ',
            imgUrl      : '/images/items/SLJ3-58.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-59',
            rare        : 'SR',
            name        : 'そふぃクラゲワンピ',
            imgUrl      : '/images/items/SLJ3-59.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-60',
            rare        : 'SR',
            name        : 'そふぃクラゲシューズ',
            imgUrl      : '/images/items/SLJ3-60.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-61',
            rare        : 'SR',
            name        : 'そふぃクラゲヘアアクセ',
            imgUrl      : '/images/items/SLJ3-61.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-62',
            rare        : 'SR',
            name        : 'ハッピーエンブレムチェリートップス',
            imgUrl      : '/images/items/SLJ3-62.png',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-63',
            rare        : 'SR',
            name        : 'ハッピーエンブレムチェリースカート',
            imgUrl      : '/images/items/SLJ3-63.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-64',
            rare        : 'SR',
            name        : 'ハッピーエンブレムチェリーシューズ',
            imgUrl      : '/images/items/SLJ3-64.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-65',
            rare        : 'SR',
            name        : 'ハッピーエンブレムチェリーヘアアクセ',
            imgUrl      : '/images/items/SLJ3-65.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-66',
            rare        : 'SR',
            name        : 'ボーイッシュキャットトップス',
            imgUrl      : '/images/items/SLJ3-66.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-67',
            rare        : 'SR',
            name        : 'ボーイッシュキャットパンツ',
            imgUrl      : '/images/items/SLJ3-67.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-68',
            rare        : 'SR',
            name        : 'キャットタイツ&アップルブーツ',
            imgUrl      : '/images/items/SLJ3-68.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-69',
            rare        : 'SR',
            name        : 'はなのプリパリルージュヘアアクセ',
            imgUrl      : '/images/items/SLJ3-69.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-70',
            rare        : 'SR',
            name        : 'ヴァンパイアシルクトップス',
            imgUrl      : '/images/items/SLJ3-70.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-71',
            rare        : 'SR',
            name        : 'ヴァンパイアシルクドレス',
            imgUrl      : '/images/items/SLJ3-71.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-72',
            rare        : 'SR',
            name        : 'ヴァンパイアシルクシューズ',
            imgUrl      : '/images/items/SLJ3-72.png',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリパラ5しゅうねん福袋その2',
            id          : 'SLJ3-73',
            rare        : 'SR',
            name        : 'アンティークペールパープルヘアアクセ',
            imgUrl      : '/images/items/SLJ3-73.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
        ],
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsJR4 () {
        return _.where(this.itemsMaJor, { rare: 'JR', collection: 'すずコレクション' })
      },

      itemsJR5 () {
        return _.where(this.itemsMaJor, { rare: 'JR', collection: 'リングマリィコレクション' })
      },

      itemsRR () {
        return _.where(this.itemsMaJor, {  rare: 'RR' })
      },

      itemsHR () {
        return _.where(this.itemsMaJor, {  rare: 'HR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, {  rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, {  rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, {  rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, {  rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' })
      },

      itemsBrandRank () {
        return _.where(this.itemsFiltered, { collection: 'ブランドランク' })
      },

      itemsPBox () {
        return _.where(this.itemsFiltered, { collection: 'プレゼントボックス' })
      },

      itemsSummerScratch () {
        return _.where(this.itemsFiltered, { collection: 'サマースクラッチ' })
      },

      itemsJewelPact () {
        return _.where(this.itemsFiltered, { collection: 'ジュエルパクト' })
      },

      itemsDesignPalette () {
        return _.where(this.itemsFiltered, { collection: 'デザインパレット自作' })
      },

      itemsKaigaraYukata () {
        return _.where(this.itemsFiltered, { collection: 'かいがらゆかたチャンネル' })
      },

      itemsFlowerPareo () {
        return _.where(this.itemsFiltered, { collection: 'フラワーパレオチャンネル' })
      },

      itemsWildStar () {
        return _.where(this.itemsFiltered, { collection: 'すずのワイルドスターチャンネル' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定' })
      },

      itemsPriPara5th () {
        return _.where(this.itemsFiltered, { collection: 'プリパラ5しゅうねんチャンネル' })
      },

      itemsPriParaLucky1 () {
        return _.where(this.itemsFiltered, { collection: 'プリパラ5しゅうねん福袋その1' })
      },

      itemsPriParaLucky2 () {
        return _.where(this.itemsFiltered, { collection: 'プリパラ5しゅうねん福袋その2' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,2,3]">
    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>
    <template #col1>
      <ItemList title="JR ◆◆◆◆" color="#edd50f" :items="itemsJR4" />
    </template>
    <template #col2>
      <ItemList title="JR ◆◆◆◆" color="#edd50f" :items="itemsJR5" />
    </template>
    <template #col3>
      <ItemList title="RR ◆◆◆◆" color="#44cd1f" :items="itemsRR" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
    </template>
    <template #col4>
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="PR モーリー限定 ★★★" color="#55b272" :items="itemsMolly" />
    </template>
    <template #col5>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
    </template>
    <template #col6>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
    </template>
    <template #col7>
      <ItemList title="かいがらゆかたチャンネル" color="#c598ff" :items="itemsKaigaraYukata" />
      <ItemList title="フラワーパレオチャンネル" color="#c598ff" :items="itemsFlowerPareo" />
      <ItemList title="すずのワイルドスターチャンネル" color="#c598ff" :items="itemsWildStar" />
      <ItemList title="ブランドランク" color="#c598ff" :items="itemsBrandRank" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
    </template>
    <template #col8>
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
      <ItemList title="サマースクラッチ" color="#c598ff" :items="itemsSummerScratch" />
      <ItemList title="ジュエルパクト" color="#a1c0fa" :items="itemsJewelPact" />
      <ItemList title="デザインパレット自作" color="#a1c0fa" :items="itemsDesignPalette" />
    </template>
    <template #col9>
      <ItemList title="プリパラ5しゅうねん福袋その1" color="#ffa1bc" :items="itemsPriParaLucky1" />
    </template>
    <template #col10>
      <ItemList title="プリパラ5しゅうねん福袋その2" color="#ffa1bc" :items="itemsPriParaLucky2" />
      <ItemList title="プリパラ5しゅうねんチャンネル" color="#ffa1bc" :items="itemsPriPara5th" />
      <Status :date="date" :items="items" :showKira="true" :showHR="true" />
    </template>
  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // コレクショングループ間の間隔 (HR)
  .Page ::v-deep .Page__col:nth-child(3) .ItemList:nth-child(2) {
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (PR)
  .Page ::v-deep .Page__col:nth-child(4) .ItemList:nth-child(1) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (SR)
  .Page ::v-deep .Page__col:nth-child(5) .ItemList:nth-child(1) {
    .Item:nth-child(17),
    .Item:nth-child(18),
    .Item:nth-child(19),
    .Item:nth-child(20),
    .Item:nth-child(29),
    .Item:nth-child(30),
    .Item:nth-child(31),
    .Item:nth-child(32) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (R)
  .Page ::v-deep .Page__col:nth-child(6) .ItemList:nth-child(1) {
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12),
    .Item:nth-child(17),
    .Item:nth-child(18),
    .Item:nth-child(19),
    .Item:nth-child(20) {
      margin-top: $size-unit * 8;
    }
  }


  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: $size-unit * 292;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: 500px;
  //   }
  // }
</style>
